<template>
    <div class="page my-history">

        <div class="tags">
            <van-tabs :swipeable="true" v-model="category_id" @click="changeCategory">
                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="item.type" :title="item.name" ></van-tab>
            </van-tabs>
            <div class="clear"></div>
        </div>

        <div class="live-list-section" v-if="type === 4 && list && list.length > 0">
            <van-row @click="go_live_detail(item)" v-for="item in list" :key="item.id">
                <div class="live-list-section-box">
                    <div class="live-list-section-left">
                        <img class="live-list-section-left-img" :src="item.cover_img">
                        <div v-if="item.live_status==0" class="live-list-section-left-zl">直播预告</div>
                        <div v-else-if="item.live_status==1" class="live-list-section-left-zl">
                            <img src="/static/bytx/activity_list_live_icon.gif" alt=""> 直播中
                        </div>
                        <div v-else class="live-list-section-left-zl">
                            直播回放
                        </div>
                        <div class="live-list-section-left-time" v-if="item.live_status>1"><span>{{item.duration_format}}</span></div>
                    </div>
                    <div class="live-list-section-right">
                        <div class="live-list-section-right-title" v-html="item.title"></div>
                        <div class="live-list-section-right-detail">
                            <span v-if="item.type === 2">{{item.live_desc}}</span>
                            <span v-else-if="item.live_status < 2">{{item.start_at}}</span>
                            <span v-else>{{item.view_count}}人观看</span>
                            <span class="live-list-section-right-detail-join"
                                  v-if="item.type === 1 && item.live_status===0">预约</span>
                            <span class="live-list-section-right-detail-join"
                                  v-else-if="item.type === 1 && item.live_status===1">加入</span>
                        </div>
                    </div>
                </div>
            </van-row>
        </div>

        <div v-if="type === 5 && list && list.length > 0" class="activity-list-section">
            <van-row class="activity-list-section-box" @click="$router.push({name: 'activity-detail',params: {id: item.id}})" v-for="item in list" :key="item.id">
                <div class="activity-list-section-left">
                    <van-image
                        fit="cover"
                        class="activity-list-section-left-img"
                        :src="item.cover_img"
                        width="100%"
                        height="100%"
                    />
                    <div v-if="item.type_text === '直播中'" class="activity-list-section-left-zl active">
                        <img src="/static/bytx/activity_list_live_icon.gif" alt="">直播中
                    </div>
                    <div v-else class="activity-list-section-left-zl">
                        {{item.type_text}}
                    </div>
                </div>
                <div class="activity-list-section-right">
                    <div class="activity-list-section-right-time">{{item.start_at}}</div>
                    <div class="activity-list-section-right-title">{{item.title}}</div>
                </div>
                <div class="clear"></div>
            </van-row>
        </div>

        <div v-if="type === 6 && list && list.length > 0" class="guide-list-section">
            <van-row class="guide-list-section-box"  @click="$router.push({name:'guide-detail',params:{id:item.id}})" v-for="item in list" :key="item.id">
                <div class="guide-list-section-left">
                    <van-image
                        fit="cover"
                        class="guide-list-section-left-img"
                        :src="item.cover_img"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="guide-list-section-right">
                    <div class="guide-list-section-right-title">{{item.title}}</div>
                    <div class="guide-list-section-right-detail">
                        <div>
                            {{item.created_at}}
                            <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </van-row>
        </div>

        <div v-if="type === 7 && list && list.length > 0" class="clinic-list-section">
            <van-row class="clinic-list-section-box" @click="$router.push({name:'clinic-detail',params:{'id':item.id}})" v-for="item in list" :key="item.id">
                <div class="clinic-list-title">
                    <span>招募</span>
                    {{item.title.length > 34 ? item.title.substr(0,34)+'...' : item.title}}
                </div>
                <div class="clinic-list-desc">
                    {{item.desc.length > 26 ? item.desc.substr(0,26)+'...' : item.desc}}
                </div>
                <div class="clinic-list-tags">
                    <span v-for="val in item.tags.split(',')">#{{val}}</span>
                </div>
            </van-row>
        </div>

        <div v-if="type === 8 && list && list.length > 0" class="community-list-section">
            <van-row class="community-list-section-box" @click="$router.push({name : 'community-detail',params : {id : item.id}})" v-for="item in list" :key="item.id">
                <div class="community-list-section-left">
                    <van-image
                        fit="cover"
                        class="community-list-section-left-img"
                        :src="item.cover_img"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="community-list-section-right">
                    <div class="community-list-section-right-title">{{item.title}}</div>
                    <div class="community-list-section-right-detail">
                        <div>
                            {{item.created_at}}
                            <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </van-row>
        </div>

        <div class="knowledge-list-sidebar-section" v-if="type===9 && list && list.length > 0">
            <van-list class="knowledge-list-sidebar-section-box">
                <van-cell is-link class="knowledge-list-sidebar-section-title" @click="$router.push({name:'knowledge-list',params:{'id':item.id}})" v-for="item in list" :key="item.id" :title="item.title" />
            </van-list>
        </div>

        <div v-if="type===10 && list && list.length > 0" class="comrade-list-section">
            <van-row @click="$router.push({name:'comrade-detail',params:{id:item.id}})" v-for="item in list" :key="item.id">
                <div v-if="item.type===1" class="comrade-list-section-box">
                    <div class="comrade-list-section-left">
                        <van-image
                            fit="cover"
                            class="comrade-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div class="comrade-list-section-right">
                        <div class="comrade-list-section-right-title">{{item.title}}</div>
                    </div>
                    <div class="clear"></div>
                    <div class="comrade-list-section-stats">
                        <img src="/static/bytx/companion_list_read_icon.svg" alt=""> <span>{{item.view_count}}</span>
                        <img src="/static/bytx/companion_list_helpful_icon.svg" alt=""> <span>{{item.comment_count}}</span>
                        <img src="/static/bytx/companion_list_comment_icon.svg" alt=""> <span>{{item.like_count}}</span>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="comrade-list-section-box" v-else>
                    <div class="comrade-list-section-title">{{item.title}}</div>
                    <van-image
                        fit="cover"
                        class="comrade-list-section-left-img"
                        :src="item.cover_img"
                        width="100%"
                        height="100%"
                    />
                    <img class="comrade-list-section-play-btn" src="/static/bytx/list_video_play_2.svg" alt="">
                    <div class="comrade-list-section-stats">
                        <img src="/static/bytx/companion_list_read_icon.svg" alt=""> <span>{{item.view_count}}</span>
                        <img src="/static/bytx/companion_list_helpful_icon.svg" alt=""> <span>{{item.comment_count}}</span>
                        <img src="/static/bytx/companion_list_comment_icon.svg" alt=""> <span>{{item.like_count}}</span>
                    </div>
                    <div class="clear"></div>
                </div>
            </van-row>
        </div>

        <div v-if="type===11 && list && list.length > 0" class="diagnose-list-section">
            <van-row class="diagnose-list-section-box" @click="$router.push({name:'diagnose-detail',params:{id:item.id},})" v-for="item in list" :key="item.id">
                <div class="diagnose-list-section-left">
                    <van-image
                        fit="cover"
                        class="diagnose-list-section-left-img"
                        :src="item.cover_img"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="diagnose-list-section-right">
                    <div class="diagnose-list-section-right-title">{{item.title}}</div>
                    <div class="diagnose-list-section-right-btn">去查看 <img src="/static/bytx/list_more_icon.svg" alt=""></div>
                </div>
                <div class="clear"></div>
                <div class="diagnose-list-section-info">{{item.desc}}</div>
            </van-row>
        </div>

        <van-empty v-if="list && list.length === 0" description="" image="/static/img/pic_blank_content.svg" >
            <template slot="description">
                <div style="text-align: center">暂无收藏哦</div>
                <div style="text-align: center;margin-top: 10px">快去观看吧！</div>
                <div style="text-align: center;margin-top: 24px">
                    <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                        返回首页
                    </van-button>
                </div>
            </template>
        </van-empty>

    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                type:1,
                active: 1,
                banners:[],
                recommend:[],
                category_id : 0,
                categories:[
                    {name:'学知识',type:9},
                    {name:'看直播',type:4},
                    {name:'近期活动',type:5},
                    {name:'就诊指南',type:6},
                    {name:'临床招募',type:7},
                    {name:'公益救助',type:8},
                    // {name:'诊断送检',type:11},
                    {name:'交流社区',type:10},
                ],
                list:[],
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'list') {
                    Interface.getData('get',Interface.user.favorite,{type:this.type,pageSize:999}).then((res)=>{
                        if(res.data.list){
                            this.list = res.data.list
                        }else{
                            this.list = []
                        }
                    })
                }
            },
            changeCategory(){
                this.type = this.categories[this.category_id].type
                this.fetch('list')
            },
            go_detail(item){
                if (item.type != 2){
                    this.$router.push({'name':'course-detail',params:{id:item.id}})
                }else{
                    this.$router.push({'name':'course-column',params:{id:item.id}})
                }
            },
            go_live_detail(item) {
                if (item.type === 2) {
                    this.$router.push({'name': 'live-column', params: {id: item.id}})
                } else if (item.live_status === 6) {
                    this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                } else {
                    if (item.live_status === 0) {
                        this.$router.push({'name': 'live-detail', params: {id: item.id}})
                    } else {
                        this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                    }
                }
            }
        },
        created() {
            this.changeCategory()
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/favorite/index.vue